export default "__VITE_ASSET__9ed74e70__"